import { useTranslation } from "react-i18next";

export const BLOOD_VALUES = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
// UI: lettera internazionale "O" (non zero) e segno meno tipografico
export const bloodLabel = (v) => (v || "").replace(/^0/, "O").replace("-", "\u2212");
// legacy interno "0+"/"0-" -> "O+"/"O-" per selezione corretta
export const bloodNorm = (v) => (v || "").replace(/^0/, "O");

export const Labeled = ({ id, label, children }) => (
  <div className="space-y-1">
    <label htmlFor={id} className="block text-sm font-medium">{label}</label>
    {children}
  </div>
);

export function MedicalField({ fieldKey, value, status, onValue, onStatus, options = [], multiline, error }) {
  const { t } = useTranslation();
  const id = `bio-field-${fieldKey}`;
  const Tag = multiline ? "textarea" : "input";
  return (
    <div className="space-y-1">
      <label htmlFor={id} className="block text-sm font-medium">
        {t(`bio.${fieldKey}`)}
        {status === "todo" && (
          <span className="ml-2 align-middle text-[11px] px-2 py-0.5 rounded-full bg-amber-100 text-amber-800" data-testid={`bio-${fieldKey}-todo-badge`}>
            {t("bio.todo_badge")}
          </span>
        )}
      </label>
      <Tag
        id={id}
        className={`yp-input w-full ${status ? "bg-slate-50 text-slate-400" : ""}`}
        placeholder={t(`bio.${fieldKey}`)}
        value={status ? "" : (value || "")}
        rows={multiline ? 2 : undefined}
        aria-invalid={!!error}
        onChange={(e) => onValue(e.target.value)}
        data-testid={`bio-${fieldKey}`}
      />
      {options.length > 0 && (
        <div role="radiogroup" aria-label={t(`bio.${fieldKey}`)} className="flex flex-col sm:flex-row gap-2 pt-1">
          {options.map((opt) => {
            const oid = `alt-${fieldKey}-${opt}`;
            const checked = status === opt;
            return (
              <label
                key={opt}
                htmlFor={oid}
                className={`flex-1 min-h-[44px] flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer text-sm leading-snug break-words ${checked ? "border-slate-800 bg-slate-50 font-medium" : "border-slate-300 hover:border-slate-400"}`}
              >
                <input
                  type="radio"
                  id={oid}
                  name={`alt-${fieldKey}`}
                  className="shrink-0 h-4 w-4"
                  checked={checked}
                  onChange={() => onStatus(opt)}
                  onClick={() => { if (checked) onStatus(""); }}
                  data-testid={`bio-${fieldKey}-${opt}`}
                />
                <span className="break-words">{opt === "none" ? t("bio.opt_none") : t("bio.opt_todo")}</span>
              </label>
            );
          })}
        </div>
      )}
      {error && <p className="text-xs text-red-600 pt-0.5" data-testid={`bio-${fieldKey}-error`}>{t("bio.required_hint")}</p>}
    </div>
  );
}

export function BloodSelect({ value, status, onChange, error }) {
  const { t } = useTranslation();
  const id = "bio-field-blood_type";
  const sel = status === "todo" ? "__todo__" : bloodNorm(value || "");
  return (
    <div className="space-y-1">
      <label htmlFor={id} className="block text-sm font-medium">{t("bio.blood_label")}</label>
      <select
        id={id}
        className="yp-input w-full"
        value={sel}
        aria-invalid={!!error}
        onChange={(e) => onChange(e.target.value)}
        data-testid="bio-blood_type"
      >
        <option value="" disabled>{t("bio.blood_placeholder")}</option>
        {BLOOD_VALUES.map((v) => <option key={v} value={v}>{bloodLabel(v)}</option>)}
        <option value="__todo__">{t("bio.blood_unknown")}</option>
      </select>
      <p className="text-xs text-slate-500 leading-snug">{t("bio.blood_hint1")}</p>
      <p className="text-xs text-slate-500 leading-snug">{t("bio.blood_hint2")}</p>
      {error && <p className="text-xs text-red-600" data-testid="bio-blood_type-error">{t("bio.required_hint")}</p>}
    </div>
  );
}
